namespace GeniuzPOS.InitialData {
    export interface PsCorperateMessageRecieptForm {
        Status: Serenity.RadioButtonEditor;
        StartDate: Serenity.DateEditor;
        EndDate: Serenity.DateEditor;
        FontSize: Serenity.StringEditor;
        TextAlign: Serenity.RadioButtonEditor;
        Desc: Serenity.TextAreaEditor;
        Image: Serenity.ImageUploadEditor;
        ActiveBy: Serenity.StringEditor;
        Activedate: Serenity.DateEditor;
    }

    export class PsCorperateMessageRecieptForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsCorperateMessageReciept';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsCorperateMessageRecieptForm.init)  {
                PsCorperateMessageRecieptForm.init = true;

                var s = Serenity;
                var w0 = s.RadioButtonEditor;
                var w1 = s.DateEditor;
                var w2 = s.StringEditor;
                var w3 = s.TextAreaEditor;
                var w4 = s.ImageUploadEditor;

                Q.initFormType(PsCorperateMessageRecieptForm, [
                    'Status', w0,
                    'StartDate', w1,
                    'EndDate', w1,
                    'FontSize', w2,
                    'TextAlign', w0,
                    'Desc', w3,
                    'Image', w4,
                    'ActiveBy', w2,
                    'Activedate', w1
                ]);
            }
        }
    }
}
